import { Easing } from '@tweenjs/tween.js';
import GameObject from '../../../GameObject/GameObject';
import TransformComponent from '../../../Component/Transform';
import AnimationClip from '../AnimationClip';

export class FriendIconIdle extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        const transform: TransformComponent = gameObject.getComponent(
            TransformComponent
        );

        const pulseTween = this.getTween(transform.scale);

        pulseTween
            .to({ x: 1.05, y: 1.05 }, 500)
            .easing(Easing.Quadratic.InOut)
            .yoyo(true)
            .repeat(Infinity);

        yield* this.startTween(pulseTween);
    }
}
